import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { X } from "lucide-react";
import { DialogTitle, DialogDescription } from "../../base/dialog/dialog";
import { cn } from "../../../utils";
import { EntityIcon } from "./EntityIcon";
export function DialogShellHeader({ icon, iconTone = "neutral", title, subtitle, eyebrow, stepper, onClose, dense = false, className, asDialogTitle = true }) {
    const TitleEl = asDialogTitle ? DialogTitle : "h3";
    const SubEl = asDialogTitle ? DialogDescription : "p";
    return /*#__PURE__*/ _jsxs("header", {
        className: cn("flex items-start justify-between gap-4", dense ? "px-5.5 pt-4.5 pb-3.5" : "px-6 pt-5.5 pb-4 border-b border-line-subtle", className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-start gap-3 min-w-0",
                children: [
                    icon && /*#__PURE__*/ _jsx(EntityIcon, {
                        icon: icon,
                        tone: iconTone,
                        size: 40
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "min-w-0 flex-1",
                        children: [
                            eyebrow && /*#__PURE__*/ _jsx("div", {
                                className: "mb-1 text-2xs font-semibold uppercase tracking-[0.10em] text-muted-foreground",
                                children: eyebrow
                            }),
                            /*#__PURE__*/ _jsx(TitleEl, {
                                className: cn("leading-tight tracking-tight font-bold text-foreground", dense ? "text-[18px]" : "text-[20px]"),
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ _jsx(SubEl, {
                                className: "mt-1 text-[13.5px] leading-[1.5] text-fg-secondary",
                                children: subtitle
                            })
                        ]
                    })
                ]
            }),
            (stepper || onClose) && /*#__PURE__*/ _jsxs("div", {
                className: "flex shrink-0 items-center gap-3",
                children: [
                    stepper,
                    onClose && /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        onClick: onClose,
                        "aria-label": "Close",
                        className: "flex h-7 w-7 items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-fg-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-bliks-green-500/50",
                        children: /*#__PURE__*/ _jsx(X, {
                            className: "h-4 w-4"
                        })
                    })
                ]
            })
        ]
    });
}

//# sourceMappingURL=DialogShellHeader.js.map